export default [
  {
    path: '/treatment/past-letters',
    component() {
      return import('@/views/treatment/PastLetters.vue')
    },
    name: 'treatment/past-letters',
    meta: {
      layout: 'blue',
    },
  },
  {
    path: '/all-exercises',
    component() {
      return import('@/views/treatment/AllExercises.vue')
    },
    name: 'all-exercises',
    meta: {
      layout: 'blue',
    },
  },
]
